import $pageConfig from 'webutils/services/page-config'

export default class NumericInputGroup {
	$onInit() {
		const $ctrl = this;
		$ctrl.$pageConfig = $pageConfig;
		if (!isFinite($ctrl.min)) $ctrl.min = 1;
		if (!isFinite($ctrl.max)) $ctrl.max = 1000;
		if (!isFinite($ctrl.step)) $ctrl.step = 1;
		if (!isFinite($ctrl.ngModel)) $ctrl.ngModel = $ctrl.min;
		$ctrl.settings = {
			preset: 'decimal',
			scale: 0,
			display: 'center',
			min: 0,
			max: $ctrl.max,
			step: $ctrl.step,
			showOnTap: true,
			onSet: $ctrl.onSet,
			onShow: function (event, inst) {
				inst.setVal('0');
			},
			buttons: [
				'cancel',
				{
					text: 'Add',
					handler: 'set'
				}
			]
		};

	}

	value(newValue,direction) {
		const $ctrl = this;
		if (newValue !== undefined && newValue !== $ctrl.ngModel) {
			if ($ctrl.ngChange) {
				$ctrl.ngChange({
					newValue,
					$direction: direction,
					value: newValue,
					$value: newValue,
					val: newValue,
					$val: newValue
				});
			}
			$ctrl.ngModel = newValue;
		}
		return $ctrl.ngModel;
	}
}
